import Vue from 'vue'
import Router from 'vue-router';
import store from './store';
import common from "@/assets/js/common";
import { queryResource } from '@/utils/permission';
Vue.use(Router);
//解决NavigationDuplicated报错    这个配置没卵用
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
    {
        path: '/',
        name: 'sysHome',
        component: () => import('./views/SysHome.vue'),
        meta:{
            title:'首页',
            menu:0,
            permission:'sysHome',
        },
    },
    {
        path: '/virtualSimulation',
        name: 'virtualSimulation',
        meta:{
            title:'虚拟仿真',
            permission:'virtualSimulation',
            menu:1
        },
        component: () => import('./views/VirtualSimulation.vue'),
        children:[
            {
                path: '/virtualSimulation/detail',
                name: 'detail',
                meta:{
                    title:'虚仿软件',
                    permission:'virtualSimulation',
                    menu:1
                },
                component: () => import('./components/virtualSimulation/Detail.vue'),
            },
        ]
    },
    {
        path: '/examineVirtual',
        name: 'examineVirtual',
        meta:{
            title:'考核仿真资源',
            permission:'examineVirtual',
            menu:1
        },
        component: () => import('./views/ExamineVirtual.vue'),
    },
    {
        path: '/course',
        name: 'course',
        meta:{
            title:'虚仿课程',
            permission:'course',
            menu:2
        },
        component: () => import('./views/Course.vue'),
        children:[
            {
                path: '/course/courseDetail',
                name: 'courseDetail',
                meta:{
                    title:'课程详情',
                    permission:'course',
                    menu:2
                },
                component: () => import('./components/course/CourseDetail.vue'),
            },
            {
                path: '/course/paper',
                name: 'paper',
                meta:{
                    title:'试卷预览',
                    permission:'course',
                    menu:2
                },
                component: () => import('./components/course/PaperView.vue'),
            },
            {
                path: '/course/studyCourse',
                name: 'studyCourse',
                meta:{
                    title:'开始学习',
                    permission:'course',
                    menu:2
                },
                component: () => import('./components/course/StudyCourse.vue'),
            },
            {
                path: '/course/createCourse',
                name: 'createCourse',
                meta:{
                    title:'创建课程',
                    permission:'course',
                    menu:2
                },
                component: () => import('./components/course/CreateCourse.vue'),
            }
        ]
    },
    {
        path: '/chatbot',
        name: 'chatbot',
        component: () => import('./views/Chatbot.vue'),
        meta:{
            title:'AI课堂',
            permission:'chatbot',
            menu:3
        },
    },
    {
        path: '/collegeCenter',
        name: 'collegeCenter',
        meta:{
            title:'院校中心',
            permission:'collegeCenter',
            menu:4
        },
        component: () => import('./views/CollegeCenter.vue'),
    },
    {
        path: '/dataCenter',
        name: 'dataCenter',
        meta:{
            title:'数据中心',
            permission:'dataCenter',
            menu:5
        },
        component: () => import('./views/DataCenter.vue')
    },
    {
        path: '/resourceLibrary',
        name: 'resourceLibrary',
        meta:{
            title:'资源库',
            permission:'resourceLibrary',
            menu:6
        },
        component: () => import('./views/ResourceLibrary.vue'),
        children:[
            {
                path: '/resourceLibrary/resourceDetail',
                name: 'resourceDetail',
                meta:{
                    title:'资源详情',
                    permission:'resourceLibrary',
                    menu:6
                },
                component: () => import('./components/resourceLibrary/ResourceDetail.vue'),
            },
            {
                path: '/resourceLibrary/fullScreenPreview',
                name: 'fullScreenPreview',
                meta:{
                    title:'ppt预览',
                    permission:'resourceLibrary',
                    menu:6
                },
                component: () => import('./components/resourceLibrary/FullScreenPreview.vue'),
            },
            {
                path: '/personCenter/paperDetail',
                name: 'paperDetail',
                meta:{
                    title:'试卷详情',
                    permission:'resourceLibrary',
                    menu:6
                },
                component: () => import('./components/personCenter/myselfPaper/PaperDetail.vue'),
            },
            {
                path: '/personCenter/softwareDetail',
                name: 'softwareDetail',
                meta:{
                    title:'虚仿软件',
                    permission:'resourceLibrary',
                    menu:6
                },
                component: () => import('./components/virtualSimulation/Detail.vue'),
            },
        ]
    },
    {
        path: '/personCenter',
        name: 'personCenter',
        meta:{
            title:'个人中心',
            permission:'personCenter',
            menu:7
        },
        component: () => import('./views/PersonCenter.vue'),
        children:[
            {
                path: '/personCenter/resourceDetail',
                name: 'personResourceDetail',
                meta:{
                    title:'资源详情',
                    permission:'personCenter',
                    menu:7
                },
                component: () => import('./components/resourceLibrary/ResourceDetail.vue'),
            },
            {
                path: '/personCenter/detail',
                name: 'personDetail',
                meta:{
                    title:'虚仿软件',
                    permission:'virtualSimulation',
                    menu:7
                },
                component: () => import('./components/virtualSimulation/Detail.vue'),
            },
        ]
    },
    {
        path: '/magSys',
        name: 'magSys',
        meta:{
            title:'教学管理',
            permission:'magSys',
            menu:8
        },
        component: () => import('./views/BackendSys.vue'),
        children:[
            {
                path: '/magSys/courseMag',
                name: 'courseMag',
                meta:{
                    title:'课程管理',
                    permission:'courseMag',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/CourseMag.vue'),
            },
            {
                path: '/magSys/resMag',
                name: 'resMag',
                meta:{
                    title:'资源管理',
                    permission:'resMag',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/ResMag.vue'),
            },
            {
                path: '/magSys/examineMag',
                name: 'examineMag',
                meta:{
                    title:'考核管理',
                    permission:'examineMag',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/ExamineMag.vue'),
            },
            {
                path: '/magSys/studentMag',
                name: 'studentMag',
                meta:{
                    title:'学生管理',
                    permission:'studentMag',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/StudentMag.vue'),
            },
            {
                path: '/magSys/subMag',
                name: 'subMag',
                meta:{
                    title:'试题管理',
                    permission:'subMag',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/SubMag.vue'),
            },
            {
                path: '/magSys/resExamine',
                name: 'resExamine',
                meta:{
                    title:'资源审核',
                    permission:'resExamine',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/ResExamine.vue'),
            },
            {
                path: '/magSys/softWareMag',
                name: 'softwareMag',
                meta:{
                    title:'软件管理',
                    permission:'softwareMag',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/SoftwareMag.vue'),
            },
            {
                path: '/magSys/examine',
                name: 'examine',
                meta:{
                    title:'用户审核',
                    permission:'examine',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/personCenter/Examine.vue'),
            },
            {
                path: '/magSys/courseExamine',
                name: 'courseExamine',
                meta:{
                    title:'课程审核',
                    permission:'courseExamine',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/personCenter/CourseExamine.vue'),
            },
            {
                path: '/magSys/configHome',
                name: 'configHome',
                meta:{
                    title:'首页配置',
                    permission:'configHome',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/ConfigHome.vue'),
            },
            {
                path: '/magSys/collegeConfig',
                name: 'collegeConfig',
                meta:{
                    title:'院校中心配置',
                    permission:'collegeConfig',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/CollegeConfig.vue'),
            },
            {
                path: '/magSys/tenantShareRes',
                name: 'tenantShareRes',
                meta:{
                    title:'校企资源共享',
                    permission:'tenantShareRes',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/TenantShareRes.vue'),
            },
            {
                path: '/magSys/intelligentTrain',
                name: 'intelligentTrain',
                meta:{
                    title:'智能实训',
                    permission:'intelligentTrain',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/IntelligentTrain.vue'),
            },
            {
                path: '/magSys/StudyAnalysis',
                name: 'studyAnalysis',
                meta:{
                    title:'学情分析',
                    permission:'studyAnalysis',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/StudyAnalysis.vue'),
            },
            {
                path: '/magSys/resAuth',
                name: 'resAuth',
                meta:{
                    title:'校企资源授权',
                    permission:'resAuth',
                    menu:8,
                    classify:'manage'
                },
                component: () => import('./components/backendSys/ResAuth.vue'),
            },
        ]
    },
    {
        path: '/dockingPlan',
        name: 'dockingPlan',
        meta:{
            title:'开放API',
            permission:'dockingPlan',
            menu:9
        },
        component: () => import('./views/DockingPlan.vue'),
    },
    {
        path: '/virtualTest',
        name: 'virtualTest',
        meta:{
            title:'考核任务实训',
            permission:'virtualTest',
            menu:10
        },
        component: () => import('./views/VirtualTest.vue'),
    },
    {
        path: '/theoryTest',
        name: 'theoryTest',
        meta:{
            title:'理论考核',
            permission:'theoryTest',
            menu:11
        },
        component: () => import('./views/TheoryTest.vue'),
    },
    {
        path: '/adminLogin',
        name: 'adminLogin',
        component: () => import('./views/AdminLogin.vue')
    },
    {
        path: '/403',
        name: '403',
        component: () => import('./views/403.vue')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('./views/404.vue')
    },
    {path: '*', component: () => import('./views/404.vue')}
]

const router = new Router({
    mode: 'history',
    isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
    routes: globalRoutes
})
//前置路由守卫
var isFirst=true;
let intoLogin=false;
router.beforeEach(async (to, from, next) => {
    store.commit('manage/changeMag',to.meta.classify=='manage'?true:false);
    let token = common.getCookie("token");
    let tenantId = common.getCookie("tenantId");
    if(token&&isFirst){
        isFirst=false;
        await queryResource();
    }
    if(tenantId==-1){
        next();
        return;
    }
    if(['*','/','/404','/403','/AdminLogin','/virtualTest','/theoryTest'].includes(to.path)){
        next();
        return;
    }
    token&&store.commit('isShowPersonCenter',true);
    var menuList=[...store.state.menu.navList,...store.state.menu.magSysList];
    var e=isMenu(menuList,to.meta.permission);
    if(e&&e.show){
        next();
    }
    else{
        if(!token){
            intoLogin=true;
            next({path:'/'});
        }else{
            next({path:'/404'});
        }
    }
})
router.afterEach(()=>{
    store.commit('changeGoLogin',false);
    if(intoLogin){
        store.commit('changeGoLogin', 'login');
        intoLogin=false;
    }
})
/**递归判断有没有菜单 */
function isMenu(data,str){
    for(let item of data){
        if(item.value==str){
            return item;
        }else{
            if(item.children&&item.children.length>0){
                var flag=isMenu(item.children,str);
                if(flag)return flag;
            }
        }
    }
    return false;
};
export default router



